var map = {
	"./capa-hover-direito.png": "8e81",
	"./capa-hover-educacao.png": "4d5a",
	"./capa-hover-livro.png": "11aa",
	"./capa-hover-saude.png": "62a1",
	"./capa-hover-simulado.png": "5117",
	"./capa-hover-tecnologia.png": "d8bf",
	"./capa-hover-video.png": "4a54"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2aa1";